import { useGetAdmin, useUpdateAdmin } from "@entities/admin";
import { useGetRoles } from "@entities/admin/lib/hooks/useGetRoles";
import { AdminUpdateForm } from "@entities/admin/ui/AdminUpdateForm";
import { ToastService } from "@shared/lib/services";
import { ACCOUNT_STATUS, AdminUser } from "@shared/lib/types";
import { CircularProgress } from "@shared/ui";
import { Modal, Row, Space, Switch } from "antd";
import { useEffect, useState } from "react";
import { BrandPermissionCard } from "./BrandPermissions/BrandPermissionCard";
import { EmployeeCard } from "./EmployeeCard";
import { PermissionCard } from "./PermissionCard";
import styles from "./styles.module.scss";

interface Props {
  employeeId: string;
  handleClose: () => void;
}

export function ManageEmployee({ employeeId, handleClose }: Props) {
  const { admin, isFetching } = useGetAdmin(employeeId);
  const { isUpdated, isUpdating, update } = useUpdateAdmin();
  const [isModalVisible, setModalVisible] = useState(false);

  const { roles, isFetching: isFetchingRoles } = useGetRoles();

  const handleSubmit = (adminData: Partial<AdminUser>) => {
    update({ data: adminData, userId: employeeId });
  };
  useEffect(() => {
    if (isUpdated) {
      ToastService.success("Employee Updated");
      setModalVisible(false);
    }
  }, [isUpdated]);

  if (isFetching || isFetchingRoles) {
    return (
      <Row justify={"center"}>
        <CircularProgress />
      </Row>
    );
  }
  if (!admin) return <></>;

  return (
    <div className={styles.content}>
      <EmployeeCard
        employee={admin}
        handleEditClick={() => setModalVisible(true)}
      />
      <PermissionCard
        selectedInitialPermissions={admin.permissions}
        permissionGroups={admin.permissionGroups || []}
      />
      <BrandPermissionCard employee={admin} />
      <div className={styles.card}>
        <Space
          style={{
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div>
            <div className={styles.permItemTitle}>Disable</div>
            <div className={styles.permItemDesc}>
              Disabled users cannot login
            </div>
          </div>

          <Switch
            checked={admin.accountStatus === ACCOUNT_STATUS.INACTIVE}
            onChange={(value) => {
              update({
                data: {
                  accountStatus: value
                    ? ACCOUNT_STATUS.INACTIVE
                    : ACCOUNT_STATUS.ACTIVE,
                },
                userId: employeeId,
              });
            }}
            loading={isUpdating}
          />
        </Space>
      </div>
      <div className={styles.card}>
        <Space
          style={{
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div>
            <div className={styles.permItemTitle}>Demo Mode</div>
            <div className={styles.permItemDesc}>
              Is Account used for demo purposes?
            </div>
          </div>
          <div></div>
          <Switch
            checked={admin.demoMode}
            onChange={(value) => {
              update({
                data: {
                  demoMode: value,
                },
                userId: employeeId,
              });
            }}
            loading={isUpdating}
          />
        </Space>
      </div>

      <Modal
        title={"Update Employee"}
        open={isModalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <AdminUpdateForm
          onSubmit={handleSubmit}
          isSubmitting={isUpdating}
          roles={Object.keys(roles || {})}
          initialValues={admin}
        />
      </Modal>
    </div>
  );
}
